export default "__VITE_ASSET__BIMMM5Hp__"